<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  progress: { type: Number, default: 0 },
  saving: { type: Boolean, default: false },
});

const emit = defineEmits(['save', 'complete']);
const { t } = useI18n();
const value = computed(() =>
  Math.min(100, Math.max(0, Number(props.progress) || 0))
);
const canComplete = computed(() => value.value === 100);
</script>

<template>
  <footer
    class="absolute bottom-0 left-0 right-0 z-30 hidden h-[82px] grid-cols-[20vw_minmax(0,80vw)] border-t border-lais-border-soft bg-white shadow-lais-soft min-[701px]:grid"
    data-test="sales-property-registration-footer"
  >
    <div
      class="flex items-start border-r border-lais-border-soft px-[22px] pt-[22px]"
    >
      <button
        type="button"
        class="inline-flex h-[50px] w-[152px] items-center justify-center gap-1 whitespace-nowrap rounded-[10px] border border-[#009F94] px-[15px] text-base font-bold leading-7 text-[#009F94] disabled:cursor-wait disabled:opacity-60"
        :disabled="saving"
        data-test="sales-property-registration-save"
        @click="emit('save')"
      >
        <span class="i-lucide-log-out size-5" aria-hidden="true" />
        {{ t('SALES_PROPERTY.ACTIONS.SAVE_AND_EXIT') }}
      </button>
    </div>
    <div class="flex min-w-0 items-center gap-5 px-[30px]">
      <div class="min-w-0 flex-1">
        <span
          class="text-xl font-bold leading-6 text-[#5D696F]"
          data-test="sales-property-registration-progress"
        >
          {{ t('SALES.COMMON.PERCENT', { value }) }}
        </span>
        <progress
          class="mt-1.5 h-1.5 w-full [&::-moz-progress-bar]:bg-[#F97316] [&::-webkit-progress-bar]:bg-[#F6C59D] [&::-webkit-progress-value]:bg-[#F97316]"
          :value="value"
          max="100"
          :aria-label="t('SALES.FOOTER.PROGRESS')"
          data-test="sales-property-registration-progress-bar"
        />
        <p v-if="!canComplete" class="mt-1 text-base text-[#334155]">
          {{ t('SALES_PROPERTY.FOOTER.ONUS_REQUIRED') }}
        </p>
      </div>
      <button
        type="button"
        class="h-[60px] w-[268px] shrink-0 rounded-[10px] border border-transparent bg-[#009F94] px-0 text-base font-bold leading-7 text-white disabled:border-[#A7B7BE] disabled:bg-[#A7B7BE]"
        :disabled="!canComplete || saving"
        data-test="sales-property-registration-complete"
        @click="emit('complete')"
      >
        {{ t('SALES_PROPERTY.FOOTER.COMPLETE') }}
      </button>
    </div>
  </footer>
</template>
